import { render, staticRenderFns } from "./CompanyApprovalBadge.vue?vue&type=template&id=a0fcf638&scoped=true"
import script from "./CompanyApprovalBadge.vue?vue&type=script&lang=js"
export * from "./CompanyApprovalBadge.vue?vue&type=script&lang=js"
import style0 from "./CompanyApprovalBadge.vue?vue&type=style&index=0&id=a0fcf638&prod&lang=scss&scoped=true"
import style1 from "./CompanyApprovalBadge.vue?vue&type=style&index=1&id=a0fcf638&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0fcf638",
  null
  
)

export default component.exports